import lodash from 'lodash';
import { _loadWidget } from './_loadWidget';

const labelSelector = '.src-component-Launcher-label';
const iconSelector = '.src-component-Launcher-icon svg';

export default class Zendesk {
    constructor(args = {}) {
        const { user } = args;

        this.user = user || null;
        this.toggle = false;

        // this.widget is an iframe that contains the zendesk widget
        this.widget = () => document.querySelector('#launcher');
    }

    setWidgetSettings(properties) {
        this._setWidgetSettings(properties);
    }

    loadWidget() {
        _loadWidget();

        return this._isWidgetLoaded();
    }

    setUserIdentity() {
        this._setUserIdentity();
    }

    addClassToWidgetIframe(className) {
        this.widget().classList.add(className);
    }

    addStylesToWidgetLabel(styles) {
        const { contentDocument } = this.widget();
        const label = contentDocument.querySelector(labelSelector);

        if (label) {
            label.setAttribute('style', styles);
        }
    }

    hideWidgetLabelIcon() {
        const { contentDocument } = this.widget();
        const icon = contentDocument.querySelector(iconSelector);
        if (icon) {
            icon.setAttribute('style', 'display: none;');
        }
    }

    showWidgetDefaultButton() {
        this.widget().style.display = 'block';
    }

    toggleWidget() {
        if (document.getElementById('Embed')) {
            this.toggle = true;
        }
        else {
            this.toggle = false;
        }

        if (this.toggle) {
            this._hideWidget();
            this.toggle = false;
        } else {
            this._activateWidget();
            this.toggle = true;
        }
    }

    removeWidget() {

        const {parentNode, parentNode : { parentNode : launcherDiv = {} } = {}} = this.widget();
        launcherDiv.removeChild && launcherDiv.removeChild(parentNode);

        const webWidgetIframe = document.querySelector('[data-product="web_widget"]');
        const {parentNode : webWidgetDiv = {}} = webWidgetIframe;
        webWidgetDiv.removeChild && webWidgetDiv.removeChild(webWidgetIframe);

        const zendeskWidgetIframe = document.getElementById('zendesk-widget');
        const {parentNode : zendeskWidgetDiv = {}} = zendeskWidgetIframe;
        zendeskWidgetDiv.removeChild && zendeskWidgetDiv.removeChild(zendeskWidgetIframe);

        window.zEmbed = null;
        window.zE = null;
    }

    hideWidget() {
        this._hideWidget();
    }

    logout() {
        this._logout();
        this.removeWidget();
    }

    _isWidgetLoaded() {
        return new Promise(resolve => {
            setTimeout(() => {
                const widget = this.widget();
                if (!widget) {
                    return resolve(this._isWidgetLoaded());
                }
                resolve(true);
            }, 250);
        });
    }

    _setWidgetSettings(settings) {
        const defaultSettings = lodash.get(window, 'zESettings.webWidget', {});

        window.zESettings = {
            webWidget: {
                ...defaultSettings,
                ...settings
            }
        };
    }

    _setUserIdentity() {
        const { name, email } = this.user;
        window.zE(() => window.zE.identify({ name, email }));
    }

    _logout() {
        window.zE(() => window.zE.logout());
    }

    _activateWidget() {
        window.zE(() => window.zE.activate());
    }

    _hideWidget() {
        window.zE(() => window.zE.hide());
    }
}
